import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Autoplay } from 'swiper/modules';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { fallbackMahalleler } from './Mahalleler';
import { getNeighborhoodDevelopments } from '../../api/neighborhoodService';
import './MahalleDetail.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const MahalleDetail = () => {
  const { urlTag } = useParams();
  const [images, setImages] = useState([]);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [mahalleData, setMahalleData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let items = [];
        try {
          const response = await getNeighborhoodDevelopments();
          if (response?.isSuccess && Array.isArray(response.data)) {
            items = response.data;
          }
        } catch(e) {
          console.error("API error", e);
        }
        
        if (items.length === 0) {
          items = fallbackMahalleler;
        }

        const found = items.find(m => m.urlTag === urlTag);
        if (found) {
          setMahalleData(found);
          
          const getImageUrl = (url) => {
            if (!url) return '/assets/images/default-image.jpg';
            if (url.startsWith('http')) return url;
            
            if (url.startsWith('/assets/')) return `https://iskenderun.bel.tr${url}`;
            
            if (url.startsWith('/uploads/')) {
              const apiUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
              const apiDomain = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
              return `${apiDomain}${url}`;
            }
            
            return `https://iskenderun.bel.tr${url.startsWith('/') ? url : '/' + url}`;
          };

          let imgArray = [];
          if (found.images && found.images.length > 0) {
             imgArray = found.images.map((img, i) => ({
                 src: getImageUrl(img.imageUrl),
                 alt: img.caption || `${found.name} - Fotoğraf ${i + 1}`
             }));
          } else {
             // Fallback for static items
             const total = found.totalImages || 0;
             imgArray = Array.from({ length: total }, (_, index) => ({
                 src: `https://iskenderun.bel.tr/assets/images/mahalleler/${urlTag}/${index + 1}.jpg`,
                 alt: `${found.name} - Fotoğraf ${index + 1}`
             }));
          }
          setImages(imgArray);
        } else {
          setMahalleData({ name: 'Mahalle bulunamadı', title: '', description: '' });
        }
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [urlTag]);

  return (
    <div className="mahalle-detail-page">
      <div className="container lg-py-5">
        <div className="row xs-mx-0 d-xs-block">

            <QuickMenu />
      
          <div className="col-md-10">
            {loading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
              </div>
            ) : (
              <>
                <h1 className="page-title mb-4">{mahalleData.name}</h1>
                
                {mahalleData.title && <h3 className="mb-3">{mahalleData.title}</h3>}
                {mahalleData.description && <p className="mb-4">{mahalleData.description}</p>}

                <div className="mahalle-gallery">
              <div className="gallery-slider">
                <div className="main-slider mb-3">
                  <Swiper
                    modules={[Navigation, Thumbs, Autoplay]}
                    thumbs={{ swiper: thumbsSwiper }}
                    navigation
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    className="main-swiper"
                    slidesPerView={1}
                    spaceBetween={0}
                  >
                    {images.map((image, index) => (
                      <SwiperSlide key={index} className="slide-item">
                        <img 
                          src={image.src} 
                          alt={image.alt}
                          className="rounded shadow-sm"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="thumb-slider">
                  <Swiper
                    modules={[Thumbs]}
                    watchSlidesProgress
                    onSwiper={setThumbsSwiper}
                    slidesPerView="auto"
                    spaceBetween={10}
                    className="thumb-swiper"
                    slideToClickedSlide={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                      },
                      576: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                      },
                      992: {
                        slidesPerView: 8,
                        spaceBetween: 10,
                      },
                      1200: {
                        slidesPerView: 10,
                        spaceBetween: 10,
                      }
                    }}
                  >
                    {images.map((image, index) => (
                      <SwiperSlide key={index} className="thumb-item">
                        <img 
                          src={image.src} 
                          alt={image.alt}
                          className="rounded"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
    
};

export default MahalleDetail;
